/**
 * Reusable Drawer Component
 * Integrates with the existing scroll lock system from theme.liquid
 */
class Drawer {
  constructor() {
    this.drawer = null;
    this.overlay = null;
    this.closeButton = null;
    this.content = null;
    this.isOpen = false;
    this.init();
  }

  init() {
    this.createDrawer();
    this.bindEvents();
  }

  createDrawer() {
    // Create drawer structure
    this.drawer = document.createElement("div");
    this.drawer.className = "drawer";
    this.drawer.innerHTML = `
      <div class="drawer-overlay"></div>
      <div class="drawer-content">
        <div class="drawer-header">
          <button type="button" class="drawer-close" aria-label="Close">
            <span>&times;</span>
          </button>
        </div>
        <div class="drawer-body">
          <!-- Content will be inserted here -->
        </div>
      </div>
    `;

    // Cache elements
    this.overlay = this.drawer.querySelector(".drawer-overlay");
    this.closeButton = this.drawer.querySelector(".drawer-close");
    this.content = this.drawer.querySelector(".drawer-body");

    // Append to body
    document.body.appendChild(this.drawer);
  }

  bindEvents() {
    // Close on overlay click
    this.overlay.addEventListener("click", () => {
      this.close();
    });

    // Close on close button click
    this.closeButton.addEventListener("click", () => {
      this.close();
    });

    // Close on ESC key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        this.close();
      }
    });
  }

  open(content) {
    if (typeof content === "string") {
      this.content.innerHTML = content;
    } else if (content instanceof HTMLElement) {
      this.content.innerHTML = "";
      this.content.appendChild(content);
    }

    this.drawer.classList.add("is-open");
    this.isOpen = true;

    // Use the existing scroll lock system
    if (window.scrollLock) {
      window.scrollLock.lockScroll();
    }
  }

  close() {
    // Pause any playing videos
    const videos = this.drawer.querySelectorAll('video');
    videos.forEach(video => {
      if (!video.paused) {
        video.pause();
      }
    });

    this.drawer.classList.remove("is-open");
    this.isOpen = false;

    // Use the existing scroll lock system
    if (window.scrollLock) {
      window.scrollLock.unlockScroll();
    }
  }
}

// Create global instance
window.drawer = new Drawer();

// Global function for opening option help pages
function openOptionHelp(blockId, helpText) {
  // Try to find a hidden container with the block content
  const hiddenContainer = document.querySelector(`#option-help-${blockId}`);

  if (hiddenContainer) {
    // Clone the content to avoid moving the original
    const contentClone = hiddenContainer.cloneNode(true);
    contentClone.style.display = "block";
    contentClone.id = "";
    window.drawer.open(contentClone);
  } else {
    // Fallback: show error message if container not found
    console.error("Could not find option help content for:", blockId);
    const errorContent = `
      <div class="option-help-content">
        <h2 style="margin-bottom: 1.5rem; text-align: center;">${helpText}</h2>
        <p style="text-align: center;">Sorry, the help content could not be found.</p>
      </div>
    `;
    window.drawer.open(errorContent);
  }
}

// Function to load page content via AJAX
function loadPageContent(pageHandle, helpText) {
  fetch(`/pages/${pageHandle}`)
    .then((response) => response.text())
    .then((html) => {
      // Parse the HTML to extract the page content
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const pageContent = doc.querySelector(".rte, .page-content, main .container, .main-content, .content");

      if (pageContent) {
        // Create a container for the drawer
        const drawerContent = document.createElement("div");
        drawerContent.className = "option-help-content";
        drawerContent.innerHTML = `
          <h2 style="margin-bottom: 1.5rem; text-align: center;">${helpText}</h2>
          ${pageContent.innerHTML}
        `;
        window.drawer.open(drawerContent);
      } else {
        // Fallback: show the entire page body content
        const bodyContent = doc.querySelector("main") || doc.querySelector("body");
        if (bodyContent) {
          const drawerContent = document.createElement("div");
          drawerContent.className = "option-help-content";
          drawerContent.innerHTML = `
            <h2 style="margin-bottom: 1.5rem; text-align: center;">${helpText}</h2>
            <div style="max-width: none;">${bodyContent.innerHTML}</div>
          `;
          window.drawer.open(drawerContent);
        } else {
          console.error("Could not load page content for:", pageHandle);
        }
      }
    })
    .catch((error) => {
      console.error("Error loading page content:", error);
      // Show error message in drawer
      const errorContent = `
        <div class="option-help-content">
          <h2 style="margin-bottom: 1.5rem; text-align: center;">${helpText}</h2>
          <p style="text-align: center;">Sorry, the help content could not be loaded at this time.</p>
        </div>
      `;
      window.drawer.open(errorContent);
    });
}
